import { render, staticRenderFns } from "./SaveData.vue?vue&type=template&id=1b9f7c72"
import script from "./SaveData.vue?vue&type=script&lang=js"
export * from "./SaveData.vue?vue&type=script&lang=js"
import style0 from "./SaveData.vue?vue&type=style&index=0&id=1b9f7c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports